import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './card.module.css'

const noop = Function.prototype

const propTypes = {
    buttonComponent: PropTypes.func,
    children: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    className: PropTypes.string,
    onButtonClick: PropTypes.func,
    subTitle: PropTypes.string,
    text: PropTypes.string
}

const defaultProps = {
    buttonComponent: null,
    onButtonClick: noop
}

/**
 * At the moment, with respect to styling, having both button and subtitle is nt supported.
 *
 * @param {ReactElement} [props.buttonComponent=null] - Optional button component
 * @param {ReactElement} [props.children] - The jsx children to be rendered
 * @param {string} [props.className] - Optional classname for the card header
 * @param {Function} [props.onButtonClick=noop] - Callback when button component get's clicked
 * @param {string} [props.subTitle] - Subtitle content
 * @param {string} [props.text] - Text content
 * @returns {ReactElement}
 */
export function CardHeader(props) {
    const { buttonComponent: Button, children, className, onButtonClick, subTitle, text } = props
    const subTitleElement = subTitle ? <span className={styles['card-sub-header']}>{subTitle}</span> : null
    const buttonElement = Button ? (
        <Button onClick={onButtonClick} className={cx(styles['card-header-button'], 't3sel-card-button')} />
    ) : null

    return (
        <h4 className={cx(styles['card-header'], className, 't3sel-card-header')}>
            <span>{text || children}</span>
            {subTitleElement}
            {buttonElement}
        </h4>
    )
}

CardHeader.propTypes = propTypes
CardHeader.defaultProps = defaultProps
